let totalCustomProductPrice = 0

const setTotalYMQCustomProductPriceTo_0 = () => {
  totalCustomProductPrice = 0
}

// update Checkout Total Cost Price
const updateCheckoutTotalCostPrice = (totalCartCost, CartCurrencyCode) => {
  try {
    // console.log(totalCartCost)
    // console.log(totalCustomProductPrice)
    // console.log(CartCurrencyCode)
    totalCartCost = (+totalCartCost) + totalCustomProductPrice,
      // console.log( totalCartCost.toFixed(2) )
      updateCheckoutButtonMinicart(`${totalCartCost.toFixed(2)} ${CartCurrencyCode}`)
    if (document.getElementsByClassName("cart__total-container").length !== 0) {
      document.getElementsByClassName("cart__total-container")[0].childNodes[3].innerText =
        "$" + `${totalCartCost.toFixed(2)} ${CartCurrencyCode}`
    }
  } catch (error) {
    console.log(error)
  }

}
//===============

const priceOfVariant_schutt = {
//F7 AiR Standard
499.99: "gid://shopify/ProductVariant/46404175298797",
514.99: "gid://shopify/ProductVariant/46404174053613",
529.99: "gid://shopify/ProductVariant/46404175855853",
// F7 AiR Elite  
699.99: "gid://shopify/ProductVariant/46404174741741",
714.99: "gid://shopify/ProductVariant/46404174971117",
729.99: "gid://shopify/ProductVariant/46404175167725",
//F7 PRO
1499.99: "gid://shopify/ProductVariant/46404415357165",
1514.99: "gid://shopify/ProductVariant/46404415422701",
1529.99: "gid://shopify/ProductVariant/46404415488237",
//F7 2.0 Collegiate
419.99: "gid://shopify/ProductVariant/49004788875501",
434.99: "gid://shopify/ProductVariant/49004788908269",
449.99: "gid://shopify/ProductVariant/49004788941037",
//F7 2.0 Professional
544.99: "gid://shopify/ProductVariant/49004788973805",
559.99: "gid://shopify/ProductVariant/49004789006573",
574.99: "gid://shopify/ProductVariant/49004789039341",
//F7 AiR Youth Standard
199.99: "gid://shopify/ProductVariant/46404175233261",
214.99: "gid://shopify/ProductVariant/46404174381293",
229.99: "gid://shopify/ProductVariant/46404175036653",
//F7 AiR Youth Elite
379.99: "gid://shopify/ProductVariant/46547700744429",
394.99: "gid://shopify/ProductVariant/46547704381677",
409.99: "gid://shopify/ProductVariant/46547711164653",
// F7 LX1
259.99: "gid://shopify/ProductVariant/49004795527405",
274.99: "gid://shopify/ProductVariant/49004795560173",
289.99: "gid://shopify/ProductVariant/49004795592941",
}


const priceOfVariant_vicis = {
  864.99: "gid://shopify/ProductVariant/43747805069561",
  929.99: "gid://shopify/ProductVariant/43747805102329",
  899.99: "gid://shopify/ProductVariant/43747805135097",
  964.99: "gid://shopify/ProductVariant/43747805167865",
  1029.99: "gid://shopify/ProductVariant/43747805200633",
  999.99: "gid://shopify/ProductVariant/43747805233401",
  1064.99: "gid://shopify/ProductVariant/43747805266169",
  814.99: "gid://shopify/ProductVariant/43747805298937",
  879.99: "gid://shopify/ProductVariant/43747805331705",
  849.99: "gid://shopify/ProductVariant/43747805364473",
  914.99: "gid://shopify/ProductVariant/43747805397241",
  979.99: "gid://shopify/ProductVariant/43747805430009",
  949.99: "gid://shopify/ProductVariant/43747805462777",
  1014.99: "gid://shopify/ProductVariant/43747805495545",
  1079.99: "gid://shopify/ProductVariant/43747805528313",
  1049.99: "gid://shopify/ProductVariant/43747805561081",
  829.99: "gid://shopify/ProductVariant/43747805593849",
  799.99: "gid://shopify/ProductVariant/43747805626617",

  649.99: "gid://shopify/ProductVariant/44124106916089",
  779.99: "gid://shopify/ProductVariant/44124106981625",
  699.99: "gid://shopify/ProductVariant/44124107014393",
  749.99: "gid://shopify/ProductVariant/44124107047161",
  464.99: "gid://shopify/ProductVariant/44124107079929",
  479.99: "gid://shopify/ProductVariant/44124107112697",
  679.99: "gid://shopify/ProductVariant/44124107145465",
  564.99: "gid://shopify/ProductVariant/44124107178233",
  729.99: "gid://shopify/ProductVariant/44124107211001",
  614.99: "gid://shopify/ProductVariant/44124107243769",
  714.99: "gid://shopify/ProductVariant/44124107276537",
  629.99: "gid://shopify/ProductVariant/44124107309305",
  449.99: "gid://shopify/ProductVariant/44124107342073",
  549.99: "gid://shopify/ProductVariant/44124107374841",
  664.99: "gid://shopify/ProductVariant/44124107407609",
  764.99: "gid://shopify/ProductVariant/44124107473145",
  599.99: "gid://shopify/ProductVariant/44124107505913",
  579.99: "gid://shopify/ProductVariant/44124107538681",
};

const findVariantID = (price, vendor) => {
  if (vendor === "vicis") {
    return priceOfVariant_vicis[`${price}`];
  } else {
    console.log("price", price)
    console.log("vendor", vendor)
    return priceOfVariant_schutt[`${price}`];
  }
};

const createListPropertiesDomElement = (attributes, lineItemDomElement) => {
  try {
    const properties = lineItemDomElement.querySelector(
      "#line_item_properties"
    );
    attributes.forEach((attribute) => {
      if (!attribute?.key) {
        return false;
      }
      let LiDomElement = document.createElement("LI");
      LiDomElement.innerHTML = attribute?.key + ": " + attribute?.value;

      if (attribute.key === "Lead Time") {
        LiDomElement.classList.add("lead_time-metafield_cart_line");
      }
      properties.appendChild(LiDomElement);
      //   console.log(attribute);
    });

  } catch (error) {
    console.log(error);
  }
};
